import { mergeLocales } from '@common/locales';
import caSharedLocale from '@common/locales/ca.json';
import deSharedLocale from '@common/locales/de.json';
import enSharedLocale from '@common/locales/en.json';
import esSharedLocale from '@common/locales/es.json';
import frSharedLocale from '@common/locales/fr.json';
import itSharedLocale from '@common/locales/it.json';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import caLocale from '../locales/ca.json';
import deLocale from '../locales/de.json';
import enLocale from '../locales/en.json';
import esLocale from '../locales/es.json';
import frLocale from '../locales/fr.json';
import itLocale from '../locales/it.json';

const localeSources = {
  en: { app: enLocale, shared: enSharedLocale },
  es: { app: esLocale, shared: esSharedLocale },
  ca: { app: caLocale, shared: caSharedLocale },
  fr: { app: frLocale, shared: frSharedLocale },
  it: { app: itLocale, shared: itSharedLocale },
  de: { app: deLocale, shared: deSharedLocale },
};

const resources = Object.fromEntries(
  Object.entries(localeSources).map(([language, { app, shared }]) => [
    language,
    { translation: mergeLocales(app, shared) },
  ]),
);

const supportedLanguages = Object.keys(resources);

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: supportedLanguages,
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    debug: false,

    // Language selection and persistence
    detection: {
      order: ['querystring', 'cookie', 'navigator', 'localStorage', 'htmlTag', 'path', 'subdomain'],
      lookupQuerystring: 'lang',
      lookupCookie: 'app_language',
      caches: ['cookie'],
      cookieMinutes: 60 * 24 * 365, // 1 year
    },

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
